export const AUTH_TOKEN = 'auth';
export const REFRESH_TOKEN = 'refresh';
